export default __webpack_public_path__ + "static/media/icon_medical_services.529a049a.svg";